<cc-box>
  <div class="lg-container" box header>
    {{'LEAD_GENERATION.CREATOR.BUBBLE.POSITION' | translate}}
    <ui-switch class="pull-right custom" [checked]="!useDefault" (change)="changeUseDefault($event)"></ui-switch>
  </div>
  <div box content *ngIf="!useDefault">
    <div class="box-part">
      <form [formGroup]="positionSettings">

        <div class="lg-container">
          <label>{{'LEAD_GENERATION.CREATOR.BUBBLE.ALIGN_TO' | translate}}</label>
          <div class="input-box">
            <mat-select
              formControlName="alignTo" name="alignTo">
              <mat-option
                *ngFor="let item of alignment_options"
                [value]="item">{{'LEAD_GENERATION.CREATOR.BUBBLE.ALIGNMENT.' + item | translate}}
              </mat-option>
            </mat-select>
          </div>
        </div>

        <div class="lg-container">
          <label>{{'LEAD_GENERATION.CREATOR.BUBBLE.SIDE_SPACING' | translate}}</label>
          <div class="input-box">
            <input formControlName="sideSpacing" type="number" name="sideSpacing">
            <span class="unit" translate>LEAD_GENERATION.CREATOR.BUBBLE.PX</span>
          </div>
        </div>

        <div class="lg-container">
          <label>{{'LEAD_GENERATION.CREATOR.BUBBLE.BOTTOM_SPACING' | translate}}</label>
          <div class="input-box">
            <input formControlName="bottomSpacing" type="number" name="bottomSpacing">
            <span class="unit" translate>LEAD_GENERATION.CREATOR.BUBBLE.PX</span>
          </div>
        </div>

      </form>
    </div>
  </div>
</cc-box>
